import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import img1 from "@/assets/marquee-1.webp";
import img2 from "@/assets/marquee-2.webp";
import img3 from "@/assets/marquee-3.webp";
import img4 from "@/assets/marquee-4.webp";
import img5 from "@/assets/marquee-5.webp";

const DEFAULT_IMAGES = [
  { id: "d1", data_url: img1, rotation: 0, scale: 1, flip_h: false, flip_v: false },
  { id: "d2", data_url: img2, rotation: 0, scale: 1, flip_h: false, flip_v: false },
  { id: "d3", data_url: img3, rotation: 0, scale: 1, flip_h: false, flip_v: false },
  { id: "d4", data_url: img4, rotation: 0, scale: 1, flip_h: false, flip_v: false },
  { id: "d5", data_url: img5, rotation: 0, scale: 1, flip_h: false, flip_v: false },
];

function transformFor(item) {
  const parts = [`rotate(${item.rotation || 0}deg)`];
  parts.push(`scaleX(${(item.flip_h ? -1 : 1) * (item.scale || 1)})`);
  parts.push(`scaleY(${(item.flip_v ? -1 : 1) * (item.scale || 1)})`);
  return parts.join(" ");
}

function objectPosFor(item) {
  const x = item.position_x == null ? 50 : item.position_x;
  const y = item.position_y == null ? 50 : item.position_y;
  return `${x}% ${y}%`;
}

export default function ImageMarquee() {
  // Start with null so we don't render defaults before we know what to show.
  const [items, setItems] = useState(null);

  useEffect(() => {
    let cancelled = false;
    api
      .get("/marquee")
      .then((r) => {
        if (cancelled) return;
        const list = Array.isArray(r.data) ? r.data : [];
        setItems(list.length > 0 ? list : DEFAULT_IMAGES);
      })
      .catch(() => {
        if (!cancelled) setItems(DEFAULT_IMAGES);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  // Reserve the vertical space during load so nothing jumps.
  if (items === null) {
    return (
      <section
        className="w-full py-4"
        data-testid="image-marquee"
        style={{ height: "216px" }}
        aria-hidden="true"
      />
    );
  }

  const track = [...items, ...items, ...items];

  return (
    <section
      className="w-full overflow-hidden py-4"
      data-testid="image-marquee"
      style={{ background: "transparent" }}
      aria-hidden="true"
    >
      <div className="marquee-track">
        {track.map((item, i) => (
          <div
            key={`${item.id}-${i}`}
            className="marquee-item"
            style={{
              flex: "0 0 auto",
              width: "280px",
              height: "200px",
              marginRight: "20px",
              borderRadius: "10px",
              overflow: "hidden",
              background: "rgba(48,23,40,0.5)",
            }}
          >
            <img
              src={item.data_url}
              alt=""
              loading="lazy"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
                objectPosition: objectPosFor(item),
                display: "block",
                transform: transformFor(item),
                transformOrigin: "center center",
                transition: "transform 250ms ease",
              }}
            />
          </div>
        ))}
      </div>
    </section>
  );
}
